import { Component, OnInit, Input } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { AppConfig } from 'client/app/app.config';
import { EventLoggerService } from '@services/event-logger-service';
import { Router } from '@angular/router';
import { RegimenService } from '@services/regimen-service/regimen.service';

const REGIMEN_IMG_BACKGROUND_CLASS = {
  variant_999: 'tw-bg-teal-100',
  variant_1499: 'tw-bg-teal-100',
  variant_1999: 'tw-bg-orange-100',
  variant_4999: 'tw-bg-blue-100',
};

@Component({
  selector: 'regimen-kit-ready',
  templateUrl: './regimen-kit-ready.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
  host: { class: 'tw-block tw-w-full' },
})
export class RegimenKitReadyComponent implements OnInit {
  @Input('user') user: any;
  @Input('userName') userName: string;
  @Input('class') class: string;
  @Input('regimen') regimen: any;
  @Input('coverImage') coverImage: string;
  @Input('doctorImage') doctorImage: string;
  @Input() showDoubleCta: boolean = false;
  concernDisplayName: string;
  regimenImageBackgroundColor: string = '';

  constructor(
    public appConfig: AppConfig,
    public conn: ConnectionService,
    private readonly eventLogger: EventLoggerService,
    private readonly router: Router,
    private readonly regimenService: RegimenService,
  ) {
  }

  get showCompactKitReadyBanner(): boolean {
    return this.regimenService.shouldShowCompactKitReadyBanner(this.regimen, this.user);
  }

  async ngOnInit(): Promise<void> {
    this.userName = this.findUserDisplayName(this.userName);
    this.concernDisplayName = this.regimen?.displayConcern?.name;
    this.setRegimenImageBackgroundColor();
  }

  findUserDisplayName(name: string): string {
    return name?.split(' ')
      .slice(0, 1)
      .join('');
  }

  setRegimenImageBackgroundColor(): void {
    const variantId = this?.regimen?.selectedVariantId;
    this.regimenImageBackgroundColor = REGIMEN_IMG_BACKGROUND_CLASS[variantId] || REGIMEN_IMG_BACKGROUND_CLASS.variant_1499;
  }

  buyRegimen(concernClass: string): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: `home-buy-${concernClass}` }));
    if (!concernClass) {
      this.router.navigate(['/user'], {
        queryParams: { tab: this.appConfig.Shared.TABS.REGIMEN },
      });
      return;
    }

    this.router.navigate(['/user'], {
      queryParams: {
        tab: this.appConfig.Shared.TABS.REGIMEN,
        class: this.regimen.class,
      }
    });
  }

  seeInstructions(): void {
    if (!this.regimen) return
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'regimen_ready_banner_how_to_use' }));
    this.router.navigate(['/user'], {
      queryParams: {
        class: this.regimen.class,
        username: this.user.get('username'),
        tab: this.appConfig.Shared.TABS.REGIMEN,
        instructions: true,
      }
    });
  }
}
